<template>
    <div>
        <h1>
            Ciao Nuovo Mondo
        </h1>
    </div>
</template>

<script>
export default {
    name: 'v1492'
}
</script>

<style scoped>
h1 {
    color: red;
}
</style>